import React, { useContext, useEffect, useState, useRef } from 'react';
import ToastContext from '../../../contextProvider/ToastContext';
import { ReactPortal } from '../../../utils/utility/react-portal';
import {
  CloseIcon,
  InfoCircleIcon,
  WarningIcon,
  CloseCircleIcon,
  CheckIcon,
} from '../../../content/svg-component';
import './alert.scss';

const Alert = ({ alert, cls }) => {
  const toastCtx = useContext(ToastContext);
  const { direction, position, floatingTime, removeAlert } = toastCtx;
  const [style, setStyle] = useState({
    animation: `${direction}-show 500ms cubic-bezier(0.175, 0.885, 0.320, 1.275)`,
  });

  const alertRef = useRef();
  let newPosX = 0,
    startPosX = 0,
    staticPosX = 0;

  const windowSize = useRef([window.innerWidth, window.innerHeight]);
  let w = windowSize.current[0] * 0.1;
  staticPosX = w + 50;

  useEffect(() => {
    setTimeout(function () {
      setStyle({
        animation: `${direction}-hide 500ms cubic-bezier(0.600, -0.280, 0.735, 0.045)`,
      });
    }, floatingTime - 500);
  }, []);

  const handleClick = (e) => {
    // e.preventDefault();
    new Promise((res) => {
      setStyle({
        animation: `${direction}-hide 500ms cubic-bezier(0.600, -0.280, 0.735, 0.045)`,
      });
      res();
    }).then(() => setTimeout(() => removeAlert(alert.id), 501));
  };
  const icons = {
    success: <CheckIcon color="#fff" />,
    info: <InfoCircleIcon color="#fff" />,
    warning: <WarningIcon color="#fff" />,
    error: <CloseCircleIcon color="#fff" size={24} />,
  };
  const status = {
    success: 'success',
    info: 'info',
    warning: 'gold',
    error: 'danger',
  };
  const changeLang = {
    [direction === 'ltr' ? 'left' : 'right']: '50px',
  };

  const timing = {
    animation: `timing ${floatingTime}ms linear alternate`,
    height: '0.3rem',
    backgroundColor: 'white',
  };

  const mouceDown = () => {
    alertRef.current.addEventListener('mousedown', function (e) {
      e.preventDefault();
      startPosX = e.clientX;

      document.addEventListener('mousemove', mouceMove);

      document.addEventListener('mouseup', function () {
        document.removeEventListener('mousemove', mouceMove);
      });
    });
  };

  const mouceMove = (e) => {
    newPosX = startPosX - e.clientX;

    // with each move we also want to update the start X and Y
    startPosX = e.clientX;
    if (alertRef.current.offsetLeft - newPosX > staticPosX) {
      alertRef.current.style.left =
        alertRef.current.offsetLeft - newPosX + 'px';
    } else {
      handleClick();
    }
  };
  // set the element's new position:

  return (
    <ReactPortal wrapperId="react-portal-toast-container" position={position}>
      <div
        className={`alertify text-white d-flex align-items-center justify-content-between border-${status[cls]} bg-${status[cls]}  mx-4`}
        key={alert.id}
        onMouseDown={mouceDown}
        ref={alertRef}
        style={{ ...style, ...changeLang }}
      >
        <div
          className={`w-100 d-flex align-items-center justify-content-between`}
          style={{ padding: '0.75rem 1.25rem' }}
        >
          <p className="d-flex align-items-center m-0">{icons[alert.class]}</p>
          <p className="d-flex align-items-center font-small m-0">
            {alert.text}
          </p>
          <div onClick={handleClick}>
            <CloseIcon color="#fff" size={16} />
          </div>
        </div>
        <div
          className={`position-absolute rounded-pill`}
          style={{ bottom: 0, ...timing }}
        ></div>
      </div>
    </ReactPortal>
  );
};

export default Alert;
